import React from 'react';
import Home from './home/index'
import './App.css';

function App() {
  return (
    <Home/>
  );
}

export default App;
